import React from "react";
import { styled } from "styled-components";

const SidebarBoxGrey = styled.div`
    padding: 20px;
    border-radius: 5px;
    & h6 {
        margin: 0 0 15px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 1.3rem;
        color: #2a5934;
    }
    & p {
        margin: 0;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
    & .sidebar-link {
        color: #2a5934;
        text-decoration: underline;
        cursor: pointer;
    }
    & .sidebar-button {
        cursor: pointer;
        background-color: #2a5934;
        color: #fff;
        display: inline-block;
        margin: 15px 0 0;
        padding: 10px 20px;
        border: 1px solid #222;
        border-radius: 5px;
        text-decoration: none;
        text-transform: uppercase;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
    }
`;

export const BecomeAMember = () => {
    
    return (
        <SidebarBoxGrey>
            <h6>Become a Member</h6> 
            <p>Would you like to help support us and our work by becoming a member of the The Friends of Queen's Wood?</p>
            <p><a className="sidebar-link" href="/membership">Click here for information</a></p>    

        </SidebarBoxGrey>
    )
}

export default BecomeAMember;
